exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#particles-js[data-v-b7b75e1a]{position:absolute;top:0;left:0;width:100%;height:100vh}", ""]);

// exports
